import { createAction, props } from '@ngrx/store';
import { SocialChannel } from '../../models';

export const LoadSocialChannels = createAction('[Social Channels] Load Social Channels');
export const LoadSocialChannelsSuccess = createAction(
  '[Social Channels] Load Social Channels Success',
  props<{ channels: SocialChannel[] }>()
);
export const LoadSocialChannelsFail = createAction('[Social Channels] Load Social Channels Fail', props<{ error: any }>());
